module.exports = __webpack_public_path__ + "static/img/album3_202501_02.cf45475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album3_202501_02.jpg
// module id = nkfL
// module chunks = 100